export const enum Tasks {
  startQuality = '0',
  startupQuality = '1',
  skateQuality = '2',
}
